import React, { useMemo } from 'react';
import { ExistingItemSC } from './existing-item.styled';
import { ReactComponent as EditIcon } from '@assets/svg/e_visit_more.svg';
import { IAddConfig, ICalendarEvent } from '@components/ui/calendar/calendars';
import { TExistingEVisitRule } from 'types/e-visits';
import { addMinutes, differenceInMinutes, format } from 'date-fns';
import { getTagColors } from '../../../../e-visits/e-visits.util';

interface ExistingItemProps {
  item: ICalendarEvent<TExistingEVisitRule | undefined>;
  onClick: (config: IAddConfig<TExistingEVisitRule>) => void;
}

const ExistingItem: React.FunctionComponent<ExistingItemProps> = ({ item, onClick }) => {
  const start = new Date(item.start);
  const end = new Date(item.end);
  const diff = item.eventData?.blockSize
    ? Math.abs(differenceInMinutes(start, end)) / item.eventData.blockSize
    : 1;
  const parts = Math.floor(diff);
  const blockSize = item.eventData?.blockSize || 1;
  const ranges = [...new Array(parts).keys()].map((k) => {
    const s = addMinutes(start, k * blockSize);
    const e = addMinutes(s, blockSize);
    return { s, e };
  });

  const { backgroundColor, textColor } = useMemo(() => {
    if (item.eventData?.tag) {
      return getTagColors(item.eventData.tag.color);
    }
    return {
      backgroundColor: '#62ab81',
      textColor: '#62ab81',
    };
  }, [item]);

  return (
    <ExistingItemSC backgroundColor={backgroundColor} textColor={textColor}>
      <button
        className="edit"
        onClick={() => {
          onClick({
            eventData: item.eventData,
            start: item.start,
            end: item.end,
            minTime: item.minTime,
            maxTime: item.maxTime,
            enableGestures: false,
          });
        }}
      >
        <EditIcon />
      </button>
      <div className="content">
        {ranges.map(({ s, e }) => (
          <div key={`${s}-${e}`} className="item">
            {format(s, 'HH:mm')} - {format(e, 'HH:mm')}
          </div>
        ))}
      </div>
    </ExistingItemSC>
  );
};

export default React.memo(ExistingItem);
